import actions from './actions'

const initialState = {
  loading: false,
  data: {},
  tabKey: "1",
  memberList: [],
  detailData: {},
  pendingAccount: [],
  approvedAccount: [],
  detailTableList: [],
  cancelledAccount: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
